const initialState = {
  loading: false,
  errors: {},
  data: [],
};

const pricePatchLineItems = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PRICE_PATCH_LINE_ITEM_LIST_REQUEST':
      return {
        ...state,
        loading: true,
        data: [],
      };
    case 'PRICE_PATCH_LINE_ITEM_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        data: payload.lineItems,
      };
    case 'PRICE_PATCH_LINE_ITEM_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default pricePatchLineItems;



// WEBPACK FOOTER //
// ./client/app/reducers/price_patch_line_items.js